export function loadCustomGtmScript(): void {
    (function(w: Window, d: Document, s: string, l: string, i: string) {
        (w as any)[l] = (w as any)[l] || [];
        (w as any)[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s) as HTMLScriptElement;
        const dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://server-side-tagging-zqai4hltia-uc.a.run.app/gtm.js?id=' + i + dl;
        f.parentNode?.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N6WBGBTT');
}
